/* =========================================================
   Kafejnica · Theme JS
   - Filter chips visual toggle (facets stay Dawn-native)
   - Peek floating card on catalog cards
   - Product gallery (thumbs + prev/next + cross-fade)
   - Quantity stepper
   - Sticky buy bar (IntersectionObserver)
   - Dark cinematic effects (cursor, glow, reveals, tilt, tape velocity)
   Everything is auto-init on DOMContentLoaded, degrades on touch.
   ========================================================= */
(function () {
  'use strict';

  var isTouch = window.matchMedia('(hover: none)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function init() {

    /* ---------- FILTER CHIPS (visual toggle) ---------- */
    document.querySelectorAll('.kaf-chip').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        // In real Shopify, chip is an <a> that navigates the facet URL.
        // If it's a plain button, just toggle visual state.
        if (chip.tagName === 'BUTTON') {
          chip.parentElement.querySelectorAll('.kaf-chip').forEach(function (c) {
            c.classList.remove('active');
          });
          chip.classList.add('active');
        }
      });
    });
    document.querySelectorAll('.kaf-view-toggle button').forEach(function (b) {
      b.addEventListener('click', function () {
        b.parentElement.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
      });
    });

    /* ---------- CATALOG PEEK ---------- */
    var peek = document.getElementById('kaf-peek');
    if (peek) {
      var peekImg = peek.querySelector('img');
      var peekName = peek.querySelector('.pn');
      var peekPrice = peek.querySelector('.pp');
      var peekActive = false;
      var pmx = 0, pmy = 0, pcx = 0, pcy = 0;

      document.querySelectorAll('.kaf-card').forEach(function (card) {
        var imgEl = card.querySelector('.img-a') || card.querySelector('img');
        var img = imgEl ? imgEl.getAttribute('src') : '';
        var peekData = (card.dataset.peek || 'Product · —').split('·').map(function (s) { return s.trim(); });
        card.addEventListener('mouseenter', function () {
          if (isTouch) return;
          peekImg.src = img;
          peekName.textContent = peekData[0];
          peekPrice.textContent = 'Starts ' + (peekData[1] || '—');
          peek.classList.add('on');
          peekActive = true;
        });
        card.addEventListener('mouseleave', function () {
          peek.classList.remove('on');
          peekActive = false;
        });
      });
      window.addEventListener('mousemove', function (e) { pmx = e.clientX; pmy = e.clientY; });
      (function peekRaf() {
        pcx += (pmx - pcx) * 0.18;
        pcy += (pmy - pcy) * 0.18;
        if (peekActive) { peek.style.left = pcx + 'px'; peek.style.top = pcy + 'px'; }
        requestAnimationFrame(peekRaf);
      })();
    }

    /* ---------- PRODUCT GALLERY + VARIANT MEDIA ---------- */
var kafGallery = null;
var stage = document.getElementById('kaf-stage-img');

if (stage) {
  var thumbs = document.querySelectorAll('.kaf-thumb');
  var counter = document.querySelector('.kaf-stage__counter b');
  var stageImages = Array.prototype.map.call(thumbs, function (thumb) {
    var image = thumb.querySelector('img');
    return thumb.dataset.src || (image ? image.src : '');
  });

  var curIdx = Array.prototype.findIndex.call(thumbs, function (thumb) {
    return thumb.classList.contains('active');
  });

  if (curIdx < 0) curIdx = 0;

  function setImage(index) {
    if (!stageImages.length) return;

    curIdx = (index + stageImages.length) % stageImages.length;

    stage.classList.add('hide');

    setTimeout(function () {
      var thumb = thumbs[curIdx];
      var thumbImage = thumb ? thumb.querySelector('img') : null;

      stage.src = stageImages[curIdx];

      if (thumb) {
        stage.dataset.mediaId = thumb.dataset.mediaId || '';
      }

      if (thumbImage && thumbImage.alt) {
        stage.alt = thumbImage.alt;
      }

      stage.classList.remove('hide');
    }, 200);

    thumbs.forEach(function (thumb, index) {
      var active = index === curIdx;
      thumb.classList.toggle('active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (counter) {
      counter.textContent = String(curIdx + 1).padStart(2, '0');
    }
  }

  function setImageByMediaId(mediaId) {
    if (!mediaId) return;

    var index = Array.prototype.findIndex.call(thumbs, function (thumb) {
      return String(thumb.dataset.mediaId) === String(mediaId);
    });

    if (index >= 0) {
      setImage(index);
    }
  }

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      setImage(index);
    });
  });

  var prev = document.getElementById('kaf-stage-prev');
  var next = document.getElementById('kaf-stage-next');

  if (prev) {
    prev.addEventListener('click', function () {
      setImage(curIdx - 1);
    });
  }

  if (next) {
    next.addEventListener('click', function () {
      setImage(curIdx + 1);
    });
  }

  kafGallery = {
    setImageByMediaId: setImageByMediaId
  };
}


/* ---------- PRODUCT OPTIONS + REAL VARIANT SYNC ---------- */
var variantsNode = document.querySelector('[data-kaf-variants]');
var mediaMapNode = document.querySelector('[data-kaf-media-map]');
var optionNamesNode = document.querySelector('[data-kaf-option-names]');
var productRoot = document.querySelector('[data-kaf-product-root]');

var kafVariants = [];
var kafMediaMap = [];
var kafOptionNames = [];


try {
  kafVariants = variantsNode
    ? JSON.parse(variantsNode.textContent || '[]')
    : [];

  kafMediaMap = mediaMapNode
    ? JSON.parse(mediaMapNode.textContent || '[]')
    : [];
} catch (error) {
  kafVariants = [];
  kafMediaMap = [];
}
kafOptionNames = optionNamesNode
  ? JSON.parse(optionNamesNode.textContent || '[]')
  : [];


function getVariantOptions(variant) {
  if (Array.isArray(variant.options)) {
    return variant.options;
  }

  return [
    variant.option1,
    variant.option2,
    variant.option3
  ].filter(function (value) {
    return value !== null && value !== undefined;
  });
}

function getSelectedOptions(root) {
  var selected = {};

  root.querySelectorAll('[data-kaf-option-group]').forEach(function (group) {
    var position = Number(group.dataset.optionPosition);
    var active = group.querySelector('.kaf-opt.active, .kaf-opt-swatch.active');

    if (active) {
      selected[position] = active.dataset.value;
    }
  });

  return selected;
}

function findMatchingVariant(selected) {
  return kafVariants.find(function (variant) {
    var options = getVariantOptions(variant);

    return Object.keys(selected).every(function (position) {
      return String(options[Number(position) - 1]) === String(selected[position]);
    });
  });
}

function isKafQuantityOption(optionName) {
  var normalized = String(optionName || '').toLowerCase();

  return (
    normalized.indexOf('quantity') !== -1 ||
    normalized.indexOf('qty') !== -1 ||
    normalized.indexOf('piece') !== -1 ||
    normalized.indexOf('cantidad') !== -1
  );
}

function formatKafVariantPrice(priceInCents) {
  var root = document.querySelector('[data-kaf-product-root]');
  var currency = root
    ? root.getAttribute('data-kaf-currency')
    : '';

  if (!currency) return '';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'code'
  }).format(Number(priceInCents || 0) / 100);
}





function syncKafVariant(root) {
  if (!root || !kafVariants.length) return;

  var selected = getSelectedOptions(root);
  var variant = findMatchingVariant(selected);

  if (!variant) return;

  var variantInput = root.querySelector('[data-kaf-variant-id]');

  if (variantInput) {
    variantInput.value = variant.id;
  }

var stickyVariantInput = document.querySelector(
  '[data-kaf-sticky-variant-id]'
);
var stickyDetails = document.querySelector(
  '[data-kaf-sticky-details]'
);
var stickyQuantity = document.querySelector(
  '[data-kaf-sticky-quantity]'
);
var stickyPrice = document.querySelector(
  '[data-kaf-sticky-price]'
);

if (stickyVariantInput) {
  stickyVariantInput.value = variant.id;
}

var detailValues = [];
var quantityValue = '';

(variant.options || []).forEach(function (optionValue, index) {
  if (!optionValue || optionValue === 'Default Title') return;

  var optionName = kafOptionNames[index] || '';

  if (isKafQuantityOption(optionName)) {
    quantityValue = optionValue;
  } else {
    detailValues.push(optionValue);
  }
});

if (stickyDetails) {
  stickyDetails.textContent = detailValues.join(' · ');
}

if (stickyQuantity) {
  stickyQuantity.textContent = quantityValue;
}

if (stickyPrice) {
  stickyPrice.textContent = formatKafVariantPrice(variant.price);
}
root.querySelectorAll(
  '[data-kaf-current-price], [data-kaf-button-price]'
).forEach(function (element) {
  element.textContent = formatKafVariantPrice(variant.price);
});

// Main product price
var mainPrice = root.querySelector('[data-kaf-current-price]');

if (mainPrice) {
  mainPrice.textContent = formatKafVariantPrice(variant.price);
}

// Compare-at price: create it when needed, hide it otherwise
var priceContainer = root.querySelector('[data-kaf-price]');
var comparePrice = root.querySelector('[data-kaf-compare-price]');
var hasDiscount = Number(variant.compare_at_price) > Number(variant.price);

if (hasDiscount && priceContainer) {
  if (!comparePrice) {
    comparePrice = document.createElement('s');
    comparePrice.setAttribute('data-kaf-compare-price', '');
    priceContainer.insertBefore(comparePrice, priceContainer.firstChild);
  }

  comparePrice.textContent = formatKafVariantPrice(variant.compare_at_price);
  comparePrice.hidden = false;
} else if (comparePrice) {
  comparePrice.hidden = true;
}

// Keep the displayed installment amount synchronized
var installmentPrice = root.querySelector('[data-kaf-installment]');

if (installmentPrice) {
  installmentPrice.textContent = formatKafVariantPrice(
    Math.floor(Number(variant.price) / 4)
  );
}

var stickyImage = document.querySelector(
  '[data-kaf-sticky-image]'
);

var stickyImageUrl = '';

if (
  variant.featured_media &&
  variant.featured_media.preview_image &&
  variant.featured_media.preview_image.src
) {
  stickyImageUrl = variant.featured_media.preview_image.src;
} else if (
  variant.featured_image &&
  variant.featured_image.src
) {
  stickyImageUrl = variant.featured_image.src;
}

if (stickyImage && stickyImageUrl) {
  stickyImage.src = stickyImageUrl;
}
  var mediaEntry = kafMediaMap.find(function (entry) {
    return String(entry.id) === String(variant.id);
  });

  if (
    mediaEntry &&
    mediaEntry.media_id &&
    kafGallery
  ) {
    kafGallery.setImageByMediaId(mediaEntry.media_id);
  }
}

document.querySelectorAll('.kaf-opts').forEach(function (group) {
  group.addEventListener('click', function (event) {
    var button = event.target.closest('.kaf-opt, .kaf-opt-swatch');

    if (!button || button.classList.contains('disabled')) return;

    group.querySelectorAll('.kaf-opt, .kaf-opt-swatch').forEach(function (option) {
      option.classList.remove('active');
      option.setAttribute('aria-pressed', 'false');
    });

    button.classList.add('active');
    button.setAttribute('aria-pressed', 'true');

    var optionGroup = button.closest('[data-kaf-option-group]');
    var valueLabel = optionGroup
      ? optionGroup.querySelector('[data-kaf-option-value]')
      : null;

    if (valueLabel) {
      valueLabel.textContent = button.dataset.value;
    }

    syncKafVariant(productRoot);
  });
});


    /* ---------- QTY STEPPER ---------- */
    document.querySelectorAll('.kaf-qty').forEach(function (q) {
      var input = q.querySelector('input');
      var btns = q.querySelectorAll('button');
      if (btns[0]) btns[0].addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (btns[1]) btns[1].addEventListener('click', function () {
        input.value = Math.min(99, parseInt(input.value || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* ---------- STICKY BUY BAR ---------- */
    var sticky = document.getElementById('kaf-stickybuy');
    var addBtn = document.querySelector('.kaf-add');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(addBtn);
    }

    /* ---------- DARK CINEMATIC (only on body.template-collection-kafejnica-dark) ---------- */
    if (document.body.classList.contains('template-collection-kafejnica-dark')) {
      initDarkEffects(isTouch);
    }

  });

  /* ============ DARK CINEMATIC MODULE ============ */
  function initDarkEffects(isTouch) {
    // Overlays
    var grain = document.createElement('div'); grain.className = 'kaf-dark-grain'; document.body.appendChild(grain);
    var glow = document.createElement('div'); glow.className = 'kaf-dark-glow'; document.body.appendChild(glow);
    var cursor = document.createElement('div'); cursor.className = 'kaf-dark-cursor';
    var label = document.createElement('span'); label.className = 'label'; cursor.appendChild(label);
    document.body.appendChild(cursor);

    if (isTouch) { cursor.style.display = 'none'; }

    // Cursor + glow follow mouse
    var mx = window.innerWidth / 2, my = window.innerHeight / 2;
    var cx = mx, cy = my, gx = mx, gy = my;
    window.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
    (function raf() {
      cx += (mx - cx) * 0.22; cy += (my - cy) * 0.22;
      cursor.style.transform = 'translate(' + cx + 'px, ' + cy + 'px) translate(-50%,-50%)';
      gx += (mx - gx) * 0.08; gy += (my - gy) * 0.08;
      glow.style.transform = 'translate3d(' + gx + 'px, ' + gy + 'px, 0) translate(-50%,-50%)';
      requestAnimationFrame(raf);
    })();

    // Cursor grow/text states
    document.querySelectorAll('a, button, .kaf-chip, .kaf-card, .kaf-hl__item, .kaf-tst__card').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursor.classList.add('grow'); });
      el.addEventListener('mouseleave', function () { cursor.classList.remove('grow', 'text'); });
    });
    document.querySelectorAll('.kaf-card').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        cursor.classList.remove('grow');
        cursor.classList.add('text');
        label.textContent = 'View';
      });
    });

    // Nav shrink on scroll
    var nav = document.querySelector('.kaf-nav');
    if (nav) {
      window.addEventListener('scroll', function () {
        nav.classList.toggle('shrink', window.scrollY > 40);
      }, { passive: true });
    }

    // Reveals with initial sweep — critical
    if ('IntersectionObserver' in window) {
      var revealEls = document.querySelectorAll('.kaf-rev-line, .kaf-rev-fade, .kaf-hero__title');
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('on');
            ro.unobserve(e.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      revealEls.forEach(function (el) { ro.observe(el); });
      requestAnimationFrame(function () {
        revealEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight * 0.95 && r.bottom > 0) {
            el.classList.add('on');
            ro.unobserve(el);
          }
        });
      });
    }

    // Counters
    function runCounter(el) {
      var end = +el.dataset.count;
      var pad = el.textContent.length;
      var n = 0; var step = Math.max(1, Math.ceil(end / 40));
      (function tick() {
        n = Math.min(end, n + step);
        el.textContent = String(n).padStart(pad, '0');
        if (n < end) requestAnimationFrame(tick);
      })();
    }
    document.querySelectorAll('[data-count]').forEach(function (c) {
      var r = c.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        runCounter(c);
      } else if ('IntersectionObserver' in window) {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            runCounter(e.target);
            cio.unobserve(e.target);
          });
        }, { threshold: 0, rootMargin: '0px 0px -5% 0px' });
        cio.observe(c);
      }
    });

    // Card 3D tilt + parallax
    if (!isTouch) {
      document.querySelectorAll('.kaf-card').forEach(function (card) {
        var inner = card.querySelector('.card-inner');
        if (!inner) return;
        var parallax = card.querySelector('.media-parallax');
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          inner.style.transform = 'rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg)';
          if (parallax) parallax.style.transform = 'translate(' + (-x * 20) + 'px, ' + (-y * 20) + 'px) scale(1.04)';
        });
        card.addEventListener('mouseleave', function () {
          inner.style.transform = '';
          if (parallax) parallax.style.transform = '';
        });
      });
    }

    // Testimonial spotlight (radial gradient follows cursor)
    document.querySelectorAll('.kaf-tst__card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
        card.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });

    // Tape scroll-velocity boost
    var tape = document.querySelector('.kaf-tape__track');
    if (tape) {
      var lastY = window.scrollY, vel = 0;
      window.addEventListener('scroll', function () {
        var dy = window.scrollY - lastY;
        vel = Math.max(-3, Math.min(3, vel + dy * 0.02));
        lastY = window.scrollY;
      }, { passive: true });
      (function tapeRaf() {
        vel *= 0.94;
        var dur = Math.max(20, 48 - Math.abs(vel) * 8);
        tape.style.animationDuration = dur + 's';
        requestAnimationFrame(tapeRaf);
      })();
    }
  }
})();
